// import React, { useState, useEffect } from "react";
// import {
//   Button,
//   Divider,
//   Grid,
//   TextField,
//   MenuItem,
//   Select,
//   InputLabel,
//   FormControl,
// } from "@mui/material";

// import toast from "react-hot-toast";
// import { useNavigate, useParams } from "react-router-dom";
// import doctorService from "../../Services/doctorService";

// const AddEditDoctors = () => {
//   const [doctorData, setDoctorData] = useState({
//     name: "",
//     specialization: "",
//     phone_no: "",
//     cnic: "",
//     email: "",
//     qualification: "",
//     pay: 0,
//     experience: "",
//     commission: 0,
//     fee: 0,
//     status: 1
//   });

//   const { id } = useParams();
//   const navigate = useNavigate();

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setDoctorData({ ...doctorData, [name]: value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       if (id) {
//         await doctorService.update(id, doctorData);
//         toast.success("Doctor updated successfully!"); // Success message
//       } else {
//         await doctorService.create(doctorData);
//          // Success message
//       }
//       navigate("/admin/hospital/doctor");
//       toast.success("Doctor added successfully!"); // Redirect after submission
//     } catch (error) {
//       toast.error("Error saving Doctor."); // Error message
//     }
//   };

//   return (
//     <form onSubmit={handleSubmit} className="w-[90%] m-auto">
//       <h1 className="m-[30px] text-center font-[700] text-[20px]">
//         {id ? "Edit Doctor" : "Add Doctor"}
//       </h1>
//       <Divider />
//       <div>
//         <div className="mt-[20px] flex">
//           <div style={{ width: "33%" }}>
//             <TextField
//               label="Doctor Name"
//               variant="outlined"
//               fullWidth
//               name="name"
//               value={doctorData.name}
//               onChange={handleChange}
//               required
//             />
//           </div>
//           <div style={{ marginLeft: 20, width: "33%" }}>
//             <TextField
//               label="Phone No."
//               variant="outlined"
//               fullWidth
//               type="number"
//               name="phone_no"
//               value={doctorData.phone_no}
//               onChange={handleChange}
//               required
//             />
//           </div>
//           <div style={{ marginLeft: 20, width: "33%" }}>
//             <TextField
//               label="CNIC"
//               variant="outlined"
//               fullWidth
//               name="cnic"
//               value={doctorData.cnic}
//               onChange={handleChange}
//               required
//             />
//           </div>
//         </div>

//         <div className="mt-[20px] flex">
//           <div style={{ width: "50%" }}>
//             <TextField
//               label="Specialization"
//               variant="outlined"
//               fullWidth
//               name="specialization"
//               value={doctorData.specialization}
//               onChange={handleChange}
//               required
//             />
//           </div>
//           <div style={{ marginLeft: 20, width: "50%" }}>
//             <TextField
//               label="Qualification"
//               variant="outlined"
//               fullWidth
//               name="qualification"
//               value={doctorData.qualification}
//               onChange={handleChange}
//               required
//             />
//           </div>
//         </div>

//         <div className="mt-[20px] flex">
//           <div style={{ width: "50%" }}>
//             <TextField
//               label="Email"
//               variant="outlined"
//               fullWidth
//               name="email"
//               value={doctorData.email}
//               onChange={handleChange}
//               required
//             />
//           </div>
//           <div style={{ marginLeft: 20, width: "50%" }}>
//             <TextField
//               label="Pay"
//               variant="outlined"
//               fullWidth
//               type="number"
//               name="pay"
//               value={doctorData.pay}
//               onChange={handleChange}
//               required
//             />
//           </div>
//         </div>

//         <div className="mt-[20px] flex">
//           <div style={{ width: "33%" }}>
//             <TextField
//               label="Commission"
//               variant="outlined"
//               fullWidth
//               type="number"
//               name="commission"
//               value={doctorData.commission}
//               onChange={handleChange}
//               required
//             />
//           </div>
//           <div style={{ marginLeft: 20, width: "33%" }}>
//             <TextField
//               label="Doctor Fee"
//               variant="outlined"
//               fullWidth
//               type="number"
//               name="fee"
//               value={doctorData.fee}
//               onChange={handleChange}
//               required
//             />
//           </div>
//           <div style={{ marginLeft: 20, width: "33%" }}>
//             <TextField
//               label="Experience"
//               variant="outlined"
//               fullWidth
//               type="number"
//               name="experience"
//               value={doctorData.experience}
//               onChange={handleChange}
//               required
//             />
//           </div>
//         </div>

//         <Grid container style={{ justifyContent: "center", marginTop: "30px" }}>
//           <Button
//             variant="contained"
//             type="submit"
//             color="primary"
//             size="large"
//             className="!bg-gray-700 !text-white"
//             style={{ borderRadius: "10px" }}
//           >
//             Save and Continue
//           </Button>
//         </Grid>
//       </div>
//     </form>
//   );
// };

// export default AddEditDoctors;

import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import doctorService from "../../Services/doctorService";

const AddEditDoctors = () => {
  const [doctorData, setDoctorData] = useState({
    name: "",
    specialization: "",
    phone_no: "",
    cnic: "",
    email: "",
    qualification: "",
    pay: 0,
    experience: "",
    commission: 0,
    fee: 0,
    status: 1,
  });
  const [loading, setLoading] = useState(false);

  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      const fetchDoctor = async () => {
        try {
          const response = await doctorService.fetchById(id);
          setDoctorData(response.doctor);
        } catch {
          toast.error("Error fetching Doctor data.");
        }
      };
      fetchDoctor();
    }
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDoctorData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      if (id) {
        await doctorService.update(id, doctorData);
        toast.success("Doctor updated successfully!");
      } else {
        await doctorService.create(doctorData);
        toast.success("Doctor added successfully!");
      }
      navigate("/admin/hospital/doctor");
    } catch {
      toast.error("Error saving Doctor.");
    } finally {
      setLoading(false);
    }
  };

  const inputClass =
    "w-full px-3 py-2 text-sm text-gray-800 bg-white border border-gray-200 rounded-lg placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-300 transition";

  const labelClass =
    "block text-xs font-medium text-gray-500 uppercase tracking-wide mb-1.5";

  return (
    <div className="p-3 sm:p-6 font-sans">
      {/* ── Page Header ── */}
      <div className="mb-6">
        <p className="text-xs font-medium tracking-widest uppercase text-gray-500">
          {id ? "Edit Doctor" : "Add Doctor"}
        </p>
        <p className="text-xs text-gray-400 mt-0.5">
          {id
            ? "Update the doctor's details below."
            : "Fill in the details to register a new doctor."}
        </p>
      </div>

      {/* ── Form Card ── */}
      <div className="border border-gray-200 rounded-xl overflow-hidden">
        {/* Card Header */}
        <div className="bg-[#215187] px-4 py-3">
          <p className="text-[12px] text-gray-100 font-medium uppercase tracking-wide">
            Doctor Information
          </p>
        </div>

        {/* Card Body */}
        <div className="bg-white px-4 py-5 sm:px-6 sm:py-6">
          <form onSubmit={handleSubmit}>
            {/* ── Section: Personal Info ── */}
            <p className="text-[10px] font-bold uppercase tracking-widest text-gray-400 mb-3">
              Personal Details
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-5">
              <div>
                <label className={labelClass} htmlFor="name">
                  Doctor Name
                </label>
                <input
                  id="name"
                  type="text"
                  name="name"
                  placeholder="Full name"
                  value={doctorData.name}
                  onChange={handleChange}
                  required
                  className={inputClass}
                />
              </div>
              <div>
                <label className={labelClass} htmlFor="phone_no">
                  Phone No.
                </label>
                <input
                  id="phone_no"
                  type="text"
                  name="phone_no"
                  placeholder="e.g. 03001234567"
                  value={doctorData.phone_no}
                  onChange={handleChange}
                  required
                  className={inputClass}
                />
              </div>
              <div>
                <label className={labelClass} htmlFor="cnic">
                  CNIC
                </label>
                <input
                  id="cnic"
                  type="text"
                  name="cnic"
                  placeholder="e.g. 35201-1234567-1"
                  value={doctorData.cnic}
                  onChange={handleChange}
                  required
                  className={inputClass}
                />
              </div>
              <div>
                <label className={labelClass} htmlFor="email">
                  Email
                </label>
                <input
                  id="email"
                  type="email"
                  name="email"
                  placeholder="email@example.com"
                  value={doctorData.email}
                  onChange={handleChange}
                  required
                  className={inputClass}
                />
              </div>
              <div>
                <label className={labelClass} htmlFor="experience">
                  Experience (years)
                </label>
                <input
                  id="experience"
                  type="number"
                  name="experience"
                  placeholder="e.g. 5"
                  value={doctorData.experience}
                  onChange={handleChange}
                  required
                  className={inputClass}
                />
              </div>
            </div>

            <div className="border-t border-gray-100 mb-5" />

            {/* ── Section: Professional Info ── */}
            <p className="text-[10px] font-bold uppercase tracking-widest text-gray-400 mb-3">
              Professional Details
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-5">
              <div>
                <label className={labelClass} htmlFor="specialization">
                  Specialization
                </label>
                <input
                  id="specialization"
                  type="text"
                  name="specialization"
                  placeholder="e.g. Cardiologist"
                  value={doctorData.specialization}
                  onChange={handleChange}
                  required
                  className={inputClass}
                />
              </div>
              <div>
                <label className={labelClass} htmlFor="qualification">
                  Qualification
                </label>
                <input
                  id="qualification"
                  type="text"
                  name="qualification"
                  placeholder="e.g. MBBS, FCPS"
                  value={doctorData.qualification}
                  onChange={handleChange}
                  required
                  className={inputClass}
                />
              </div>
            </div>

            <div className="border-t border-gray-100 mb-5" />

            {/* ── Section: Financial Info ── */}
            <p className="text-[10px] font-bold uppercase tracking-widest text-gray-400 mb-3">
              Financial Details
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
              <div>
                <label className={labelClass} htmlFor="pay">
                  Monthly Pay (PKR)
                </label>
                <input
                  id="pay"
                  type="number"
                  name="pay"
                  placeholder="e.g. 50000"
                  value={doctorData.pay}
                  onChange={handleChange}
                  required
                  className={inputClass}
                />
              </div>
              <div>
                <label className={labelClass} htmlFor="commission">
                  Commission (%)
                </label>
                <input
                  id="commission"
                  type="number"
                  name="commission"
                  placeholder="e.g. 20"
                  value={doctorData.commission}
                  onChange={handleChange}
                  required
                  className={inputClass}
                />
              </div>
              <div>
                <label className={labelClass} htmlFor="fee">
                  Doctor Fee (PKR)
                </label>
                <input
                  id="fee"
                  type="number"
                  name="fee"
                  placeholder="e.g. 1500"
                  value={doctorData.fee}
                  onChange={handleChange}
                  required
                  className={inputClass}
                />
              </div>
            </div>

            {/* Divider */}
            <div className="border-t border-gray-100 mb-5" />

            {/* ── Actions ── */}
            <div className="flex flex-col-reverse sm:flex-row items-center justify-center gap-3">
              <button
                type="button"
                onClick={() => navigate(-1)}
                className="w-full sm:w-auto px-5 py-3 text-[13px] font-medium text-gray-600 border border-gray-200 rounded-lg bg-white hover:bg-gray-50 transition focus:outline-none focus:ring-2 focus:ring-gray-100"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={loading}
                className="w-full sm:w-auto px-6 py-3 text-[13px] font-medium text-white bg-[#2F6DB4] rounded-lg hover:bg-[#255A8C] transition focus:outline-none focus:ring-2 focus:ring-gray-300 disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center gap-2"
              >
                {loading && (
                  <svg
                    className="w-3.5 h-3.5 animate-spin"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    />
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 0 1 8-8v8z"
                    />
                  </svg>
                )}
                {loading
                  ? "Saving..."
                  : id
                    ? "Update Doctor"
                    : "Save and Continue"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddEditDoctors;
